module.exports = require("./mzn-IR.js");